module.exports = "/templates/templatephrases.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/templatephrases.html
// module id = 480
// module chunks = 0